import { action } from 'typesafe-actions';
import { SignupActionTypes, Signup } from './types';

export const signupRequest = (data: Signup) => action(SignupActionTypes.SIGNUP_REQUEST, data);
export const signupSuccess = (data: Signup) => action(SignupActionTypes.SIGNUP_SUCCESS, data);
export const signupError = (message: string) => action(SignupActionTypes.SIGNUP_ERROR, message);
